module.exports = __webpack_public_path__ + "static/img/ent-3.39bc6f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-3.jpg
// module id = 0d8a
// module chunks = 51